export const mockLocations = [
  {
    locationName: 'California',
    locationId: 'urn:blvd:Location:318d4267-3bf3-4abe-bbe4-e6fc0f896e1b',
    places: [
      {
        advanceBookingLimit: 3,
        name: 'Santa Monica',
        timezone: 'America/Los_Angeles',
        marketingSupport: {
          bookingHighlight: 'Hi🎉',
          confirmationPromo: {
            subheading: 'Book your first facial and enjoy 50% off',
            offerCode: 'FIRSTFACIAL',
            bannerColor: '#f7eee8',
            headline: 'Take 50% off your first facial',
          },
          enableNewClientPromo: true,
        },
        mapImg:
          'https://cdn.sanity.io/images/tq4wzdvz/development/2931639f04739fe93725dcde6bb36b918f94bb93-981x552.jpg',
        enableGhostBooking: true,
        address: {
          state: 'CA',
          zipCode: '90405',
          city: 'Santa Monica',
          streetAddress: '2919 Main St.',
        },
        contact: {
          email: 'abundantsalon+la@example.com',
          phone: '+13103555555',
        },
        enableMembershipFlow: true,
        id: 'urn:blvd:Location:318d4267-3bf3-4abe-bbe4-e6fc0f896e1b',
        openDate: '2022-08-17',
      },
    ],
  },
  {
    locationName: 'New York',
    locationId: 'urn:blvd:Location:c496ea57-0a49-473f-9558-8ffb1a10b68a',
    places: [
      {
        address: {
          zipCode: '10010',
          city: 'Nomad',
          streetAddress: '1130 Broadway',
          state: 'NY',
        },
        enableGroupBooking: false,
        enableGhostBooking: false,
        mapImg:
          'https://cdn.sanity.io/images/tq4wzdvz/development/a50b669bb5d7f86210f92491e6808bbb045adfad-327x184.svg',
        advanceBookingLimit: 3,
        openDate: '2023-09-05',
        marketingSupport: {
          confirmationPromo: {
            subheading: 'teaaaa',
            offerCode: 'FIRSTFACIAL',
            bannerColor: '#f7e8ed',
            headline: 'test',
          },
          enableNewClientPromo: true,
          bookingHighlight: 'Now Closed!',
        },
        id: 'urn:blvd:Location:c496ea57-0a49-473f-9558-8ffb1a10b68a',
        timezone: 'America/Los_Angeles',
        enableMembershipFlow: false,
        contact: {
          availability: [
            {
              day: 'Monday',
              availableTimes: [
                {
                  from: '12:00 AM',
                  to: '5:00 PM',
                },
              ],
            },
            {
              day: 'Tuesday',
              availableTimes: [
                {
                  from: '12:00 AM',
                  to: '5:00 PM',
                },
              ],
            },
            {
              day: 'Wednesday',
              availableTimes: [
                {
                  from: '12:00 AM',
                  to: '5:00 PM',
                },
              ],
            },
            {
              day: 'Thursday',
              availableTimes: [
                {
                  from: '12:00 AM',
                  to: '5:00 PM',
                },
              ],
            },
            {
              day: 'Friday',
              availableTimes: [
                {
                  from: '12:00 AM',
                  to: '5:00 PM',
                },
              ],
            },
            {
              day: 'Saturday',
              availableTimes: [],
            },
            {
              availableTimes: [],
              day: 'Sunday',
            },
          ],
          email: 'abundantsalon+la@example.com',
          phone: '+13103555555',
        },
        name: 'Nomad',
      },
    ],
  },
]

const typeValue = {
  type: '',
  value: '',
}

const commonFields = {
  id: '',
  name: '',
  tagIds: [],
  createdAt: '',
  orderAt: 0,
}

const commonItems = {
  title: typeValue,
  heading: typeValue,
  subheading: typeValue,
  continue_btn: typeValue,
}

export const initialLocationPageData = {
  title: typeValue,
  heading: typeValue,
  subheading: typeValue,
  sign_in: typeValue,
  locations: [
    {
      ...commonFields,
      boulevard_id: '',
      slug: '',
      contact: {
        email: '',
        phone: '',
        ...commonFields,
      },
      address: {
        streetAddress: '',
        zipCode: '',
        city: '',
        ...commonFields,
      },
      state: {
        short_name: '',
        ...commonFields,
      },
      tz: '',
      mapImg: '',
      openDate: null,
      isBookable: true,
      advanceBookingLimit: 0,
      enableMembershipFlow: true,
      enableGhostBooking: false,
      enableGroupBooking: false,
      leadSource: null,
      bookingHighlight: null,
      enableNewClientPromo: true,
      confirmationScreenPromo: {
        offerCode: '',
        subheading: '',
        ...commonFields,
      },
      locationTier: '',
      isTestLocation: false,
    },
  ],
  continue_btn: typeValue,
}

export const initialServicePageData = {
  title: typeValue,
  heading: typeValue,
  subheading: typeValue,
  sign_in: typeValue,
  continue_btn: typeValue,
  services: [
    {
      ...commonFields,
      description: '',
      isLaser: false,
      hideMemberPrice: false,
      isMembershipPrice: false,
      isMicro: false,
      icon: '',
      tier1: 0,
      tier2: 0,
      boulevard_id: '',
      boulevard_sandbox_id: '',
      category: '',
      label: '',
    },
  ],
}

export const initialEnhancementsPageData = {
  ...commonItems,
  skip_btn: typeValue,
  enhancement_type: [
    {
      ...commonFields,
      order: '0',
    },
  ],
  enhancements: [
    {
      ...commonFields,
      order: '0',
      boulevard_id: '',
      boulevard_sandbox_id: '',
      description: '',
      helpText: '',
      enhancementType: '',
      icon: '',
      label: '',
      type: '',
      visible: false,
    },
  ],
}
